
import { defineComponent, ref } from 'vue';

export default defineComponent({
  setup() {
    const message = ref('');
    return {
      message,
    };
  },
});
